import { GetterTree } from "vuex";
import { LiveCallEntry } from "@/utils/live-calls";
import { RootState } from "./state";

const getters: GetterTree<RootState, RootState> = {
  isFreeTier(state): boolean {
    return state.userLevel.level === "LEVEL_FREE";
  },
  liveCallsForReport:
    (state) =>
    (personUid: string | null, reportName: string): LiveCallEntry[] => {
      if (!personUid || !reportName) {
        return [];
      }
      const personEntries = state.liveCalls[personUid];
      if (!personEntries) {
        return [];
      }
      const normalizedReport = (reportName || "reference_check").toLowerCase();
      return personEntries[normalizedReport] || [];
    },
};

export default getters;
